// @ts-ignore
import {ApiValidation} from "../../model/api/api-validation";
import {TableRecordResult} from "../../model/api/table-record-result";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {OrderReferencePattern} from "../../model/mapping/order-reference-pattern";
import {Source} from "../../model/mapping/source";
import {Fee} from "../../model/mapping/fee";
import {SrcMappingAccountCode} from "../../model/mapping/src-mapping-account-code";
import {SrcMappingBrokerCode} from "../../model/mapping/src-mapping-broker-code";
import {SrcMappingContract} from "../../model/mapping/src-mapping-contract";
import {SrcMappingExchange} from "../../model/mapping/src-mapping-exchange";
import {SrcMappingFee} from "../../model/mapping/src-mapping-fee";
import {SrcMappingTrader} from "../../model/mapping/src-mapping-trader";
import {SrcMappingTradeType} from "../../model/mapping/src-mapping-trade-type";

export class CrystalclearMappingBackUrl {
  static readonly GET_MAPPING_ORDERREFERENCEPATTERN_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<OrderReferencePattern>> = {
    url: '/api/mapping/order-reference-pattern/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_ORDERREFERENCEPATTERN: CrystalclearBackUrl.UrlConf<ApiValidation<OrderReferencePattern>> = {
    url: '/api/mapping/order-reference-pattern/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_ORDERREFERENCEPATTERN: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/order-reference-pattern/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_FEE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Fee>> = {
    url: '/api/mapping/fee/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_FEE: CrystalclearBackUrl.UrlConf<ApiValidation<Fee>> = {
    url: '/api/mapping/fee/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_FEE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/fee/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SOURCE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Source>> = {
    url: '/api/mapping/source/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SOURCE: CrystalclearBackUrl.UrlConf<ApiValidation<Source>> = {
    url: '/api/mapping/source/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SOURCE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/source/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SRCMAPPINGACCOUNTCODE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<SrcMappingAccountCode>> = {
    url: '/api/mapping/src-mapping-account-code/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SRCMAPPINGACCOUNTCODE: CrystalclearBackUrl.UrlConf<ApiValidation<SrcMappingAccountCode>> = {
    url: '/api/mapping/src-mapping-account-code/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SRCMAPPINGACCOUNTCODE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/src-mapping-account-code/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SRCMAPPINGBROKERCODE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<SrcMappingBrokerCode>> = {
    url: '/api/mapping/src-mapping-broker-code/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SRCMAPPINGBROKERCODE: CrystalclearBackUrl.UrlConf<ApiValidation<SrcMappingBrokerCode>> = {
    url: '/api/mapping/src-mapping-broker-code/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SRCMAPPINGBROKERCODE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/src-mapping-broker-code/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SRCMAPPINGCONTRACT_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<SrcMappingContract>> = {
    url: '/api/mapping/src-mapping-contract/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SRCMAPPINGCONTRACT: CrystalclearBackUrl.UrlConf<ApiValidation<SrcMappingContract>> = {
    url: '/api/mapping/src-mapping-contract/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SRCMAPPINGCONTRACT: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/src-mapping-contract/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SRCMAPPINGEXCHANGE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<SrcMappingExchange>> = {
    url: '/api/mapping/src-mapping-exchange/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SRCMAPPINGEXCHANGE: CrystalclearBackUrl.UrlConf<ApiValidation<SrcMappingExchange>> = {
    url: '/api/mapping/src-mapping-exchange/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SRCMAPPINGEXCHANGE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/src-mapping-exchange/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SRCMAPPINGFEE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<SrcMappingFee>> = {
    url: '/api/mapping/src-mapping-fee/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SRCMAPPINGFEE: CrystalclearBackUrl.UrlConf<ApiValidation<SrcMappingFee>> = {
    url: '/api/mapping/src-mapping-fee/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SRCMAPPINGFEE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/src-mapping-fee/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SRCMAPPINGTRADER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<SrcMappingTrader>> = {
    url: '/api/mapping/src-mapping-trader/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SRCMAPPINGTRADER: CrystalclearBackUrl.UrlConf<ApiValidation<SrcMappingTrader>> = {
    url: '/api/mapping/src-mapping-trader/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SRCMAPPINGTRADER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/src-mapping-trader/delete',
    type: ApiValidation
  };

  static readonly GET_MAPPING_SRCMAPPINGTRADETYPE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<SrcMappingTradeType>> = {
    url: '/api/mapping/src-mapping-trade-type/list',
    type: TableRecordResult
  };

  static readonly SAVE_MAPPING_SRCMAPPINGTRADETYPE: CrystalclearBackUrl.UrlConf<ApiValidation<SrcMappingTradeType>> = {
    url: '/api/mapping/src-mapping-trade-type/save',
    type: ApiValidation
  };

  static readonly DELETE_MAPPING_SRCMAPPINGTRADETYPE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/mapping/src-mapping-trade-type/delete',
    type: ApiValidation
  };

}
